import { render, staticRenderFns } from "./FindologicItemFilter.vue?vue&type=template&id=12159242&scoped=true&"
import script from "./FindologicItemFilter.vue?vue&type=script&lang=ts&"
export * from "./FindologicItemFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12159242",
  null
  
)

export default component.exports